import * as marietta from '../..';
import ItemControllerBasePointInput from './ItemControllerBasePointInput';
import { Stage } from '../model';

export default class ItemControllerMobileTouchInput extends ItemControllerBasePointInput {
    /**
     * ドットの作成
     * @param MouseEvent
     */
    makeDot = (e: MouseEvent&TouchEvent) => {
      e.stopPropagation();
      // pad スマホ用タッチ座標修正
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        Stage.refreshStageMouse(<any>e);
      }
      const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
      let snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      if (this.type === 'site') snapUnit = 1; // 敷地の場合は、吸着なし
      newPoint.x = Math.round(newPoint.x / snapUnit) * snapUnit;
      newPoint.y = Math.round(newPoint.y / snapUnit) * snapUnit;
      this.stopFollowMouse();
      this.viewObj.remove();
      this.dotImage.remove();

      if (this.callbackOnComplete) {
        this.callbackOnComplete(newPoint);
      }
    }

    /**
     * マウス追従終了
     */
    stopFollowMouse() {
      const stage = document.querySelector('#layerGroup');
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        stage.removeEventListener('touchmove', this.followMouse);
        stage.removeEventListener('touchstart', this.onMouseDown);
        stage.removeEventListener('touchstart', this.onClickBase);
      } else {
        stage.removeEventListener('mousemove', this.followMouse);
        stage.removeEventListener('mousedown', this.onMouseDown);
        stage.removeEventListener('mousedown', this.onClickBase);
        stage.removeEventListener('contextmenu', ItemControllerBasePointInput.contextMenu);
      }
      ua = null;
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;

      // ペンの削除
      if( document.getElementById('controller_pen') ){
        document.getElementById('controller_pen').remove();
      }

    }
}
